import React from "react";
 import {
 FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
   FaFacebookF,
   FaInstagram,
   FaYoutube,
   FaTwitter,
   FaWhatsapp,
  FaLinkedinIn,
 } from "react-icons/fa";
import "./CSS/Footer.css";
import logo from "./IMAGES/Bhairavnath logo white.png"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Left Section */}
        <div className="footer-left">
            <img src={logo}/>
          <h2 className="footer-logo">आमच्याबद्दल</h2>
          <p className="footer-text">
           १९९२ साली स्थापन झालेले भैरवनाथ क्रीडा मंडळ मागील तीन दशकांपासून समाजसेवा, सांस्कृतिक उभारणी, पर्यावरण संवर्धन, राष्ट्रभक्ती जागृती आणि अध्यात्मिक जडणघडण या क्षेत्रांत सातत्याने कार्यरत आहे. समाजहिताचे उपक्रम राबवून मंडळाने सामाजिक ऐक्य, सांस्कृतिक जपणूक आणि आध्यात्मिक मूल्यांना चालना दिली आहे.
          </p>
        </div>

        {/* Middle Section */}
        {/* <div className="footer-middle">
          <h3 className="footer-title">महत्वाचे लिंक्स</h3>
          <ul className="footer-links">
            <a href="#home"><li>मुखपृष्ठ</li></a>
            <a href="#history"><li>मंडळाचा इतिहास</li></a>
            <li>मंडळ समिती</li>
           <a href="#samajik"><li>सामाजिक उपक्रम</li></a> 
            <li>शैक्षणिक उपक्रम</li>
            <li>संकल्पना</li>
            <li>कार्यक्रम</li>
             <a href="#gallary"><li>गॅलरी</li></a>
            <li>थेट प्रक्षेपण</li>
            <a href="#denagi"><li>देणगी</li></a> 
             <a href="#contact"><li>संपर्क</li></a>
          </ul>
        </div> */}

        {/* Right Section */}
        <div className="footer-right">
          <h3 className="footer-title">Contact Us</h3>
          <p> Phone: +91 9876543210</p>
          {/* <p> Email: bhairavnathkridamandal@gmail.com</p> */}
          <p> Website: www.bhairavnathkridamandal.online</p>

          <div className="socials-icons">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaYoutube /></a>
            {/* <a href="#"><FaTwitter /></a> */}
            <a href="#"><FaWhatsapp /></a>
            {/* <a href="#"><FaLinkedinIn /></a> */}
          </div>
        </div>
      </div>

      {/* Bottom Line */}
     <div className="footer-bottom">
  <span>© 2025 | भैरवनाथ क्रीडा मंडळ करंजे पेठ, सातारा  स्थापना - १९९२</span>
  <a
    className="copyright-2"
    href="https://designvio.in/"
    target="_blank"
    rel="noopener noreferrer"
  >
    @ 2025 Designed and Developed by Designvio Pvt.ltd
  </a>
  <a className="insta-svg" href="https://www.instagram.com/designvio_ux/">
    <FaInstagram />
  </a>
</div>

    </footer>
  );
};

export default Footer;
